// extracted by mini-css-extract-plugin
export default {"timer":"style_timer__Ziogo","time":"style_time__BI0JN","play":"style_play__9dumA","pause":"style_pause__qCPvE","disabled":"style_disabled__Yhiis"};